"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndex = void 0;
var _lodash = _interopRequireDefault(require("lodash.get"));
var _getSlidesPerView = require("./getSlidesPerView");
var _isSlidesLoopEnabled = require("./isSlidesLoopEnabled");
const getIndex = ({
  instanceRef,
  isAtTheEnd,
  isAtTheStart,
  setIsAtTheEnd,
  setIsAtTheStart,
  slider,
  slidesCount,
  type
}) => {
  const currentSlide = (0, _lodash.default)(instanceRef, 'current.track.details.rel', 0);
  const slidesLoopEnabled = (0, _isSlidesLoopEnabled.isSlidesLoopEnabled)(slider);
  const slidesPerView = (0, _getSlidesPerView.getSlidesPerView)(slider);
  if (type === 'next') {
    if (Boolean(slidesLoopEnabled) && isAtTheEnd) {
      setIsAtTheEnd(false);
      setIsAtTheStart(true);
      return 0;
    }
    if (currentSlide + slidesPerView >= slidesCount - slidesPerView) {
      setIsAtTheEnd(true);
      setIsAtTheStart(false);
      return slidesCount - slidesPerView;
    }
    setIsAtTheEnd(false);
    setIsAtTheStart(false);
    return currentSlide + slidesPerView;
  }
  if (slidesLoopEnabled && isAtTheStart) {
    setIsAtTheEnd(true);
    setIsAtTheStart(false);
    return slidesCount - slidesPerView;
  }
  if (currentSlide - slidesPerView <= 0) {
    setIsAtTheEnd(false);
    setIsAtTheStart(true);
    return 0;
  }
  setIsAtTheEnd(false);
  setIsAtTheStart(false);
  return currentSlide - slidesPerView;
};
exports.getIndex = getIndex;
//# sourceMappingURL=getIndex.js.map